
<div class="alert alert-warning text-center" role="alert">
  Oups ! La page que vous recherchez semble introuvable...
</div>


<div class="text-center">
  <img src="assets/img/404.gif">
</div>